// extracted by mini-css-extract-plugin
export default {"main":"VersionHistoryItem_main__2wx1V","heading":"VersionHistoryItem_heading__wFcCJ"};